(function(){
    'use strict';
    const tabs = document.querySelectorAll('[role="tab"]');
    const panels = document.querySelectorAll('[role="tabpanel"]');
    const back = document.getElementById("in-page-nav-back");
    const forward = document.getElementById("in-page-nav-forward");

    const navigationHandler = function () {
        tabs.forEach((tab) => {
            if (tab.classList.contains("is-active")) {
                
                if(tab.id==="tab1id"){
                    back.style.display = "none";
                    forward.style.display= "inline-block";
                    forward.innerHTML = tab.nextElementSibling.innerHTML;
                    forward.href = tab.nextElementSibling.href;
                    forward.addEventListener('click', ()=>{
                        tab.nextElementSibling.click();
                    });
                }
                if(tab.id==="tab2id"){
                    back.style.display= "inline-block";
                    forward.style.display= "inline-block";
                    back.innerHTML = tab.previousElementSibling.innerHTML;
                    back.href = tab.previousElementSibling.href;
                    back.addEventListener('click', ()=>{
                        tab.previousElementSibling.click();
                    });
                    forward.innerHTML = tab.nextElementSibling.innerHTML;
                    forward.href = tab.nextElementSibling.href;
                    forward.addEventListener('click', ()=>{
                        tab.nextElementSibling.click();
                    });
                }
                if(tab.id==="tab3id"){
                    back.style.display= "inline-block";
                    forward.style.display= "none";
                    back.innerHTML = tab.previousElementSibling.innerHTML;
                    back.href = tab.previousElementSibling.href;
                    back.addEventListener('click', ()=>{
                        tab.previousElementSibling.click();
                    });
                }
            }
        });
    };
    
    // On page load
    navigationHandler();

    // When a tab is clicked, activateTab is fired to activate it
    const clickEventListener = function(event) {
        
        activateTab(event.target, false);
        navigationHandler();
    }

    // Activates any given tab panel
    const activateTab = function(tab,setFocus){
        setFocus = setFocus || true;
        // Deactivate all other tabs
        deactivateTabs();
        
        // Remove tabindex attribute
        tab.removeAttribute('tabindex');

        // Set the tab as selected
        tab.setAttribute('aria-selected', 'true');
        tab.classList.add('is-active');

        // Get the value of aria-controls (which is an ID)
        var controls = tab.getAttribute('aria-controls');

        // Remove is-hidden class from tab panel to make it visible
        document.getElementById(controls).classList.remove('is-hidden');

        // Set focus when required
        if (setFocus) {
            tab.focus();
        }
    };

    // Deactivate all tabs and tab panels
    const deactivateTabs = function() {
        tabs.forEach( (tab) => {
            tab.setAttribute('tabindex', '-1');
            tab.setAttribute('aria-selected', 'false');
            tab.classList.remove('is-active');
        });
        panels.forEach( (panel) => {
            panel.classList.add('is-hidden');
        });    
    }

    // Add click event listener to all tabs
    tabs.forEach( (tab) => {
        tab.addEventListener('click', clickEventListener);
    });

    if(tabs && tabs.length === 3) {
        const href = window.location.href.split('#');
            const currentTab = href.length>1 ? href[1] : '';
            switch(currentTab) {
                case 'overview':
                    tabs[0].click();
                    break;
                case 'what-you-study':
                    tabs[1].click();
                    break;
                case 'ready-to-enrol':
                    tabs[2].click();
                    break;
            }
            window.showTable = function(){
                tabs[2].click();
            }
        }


}());
